
export default class AppError extends Error {
  userMessage;
  developerMessage;
  code;
  exceptionType;

  constructor(message, userMessage,developerMessage,code,exceptionType) {
    super(message);
    this.userMessage = userMessage;
    this.developerMessage = developerMessage;
    this.code = code;
    this.exceptionType = exceptionType;
  }
}